import { Box, Heading, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import { useAiPlanTitle, useTitleKey } from '../../hooks';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import s from './PageTitle.scss';
import { useDomainNamePageTitle } from './useDomainNamePageTitle';

export interface PageTitleProps {
  dataHook?: string;
}

export const PageTitle = ({ dataHook }: PageTitleProps) => {
  const { Trans } = EclipsePackagePickerModule.internals.useTranslations();
  const { key, params, isLoading: isTitleKeyLoading } = useTitleKey();
  const { aiTitle, isLoading: isAiTitleLoading } = useAiPlanTitle();
  const domainContent = useDomainNamePageTitle(key);

  const isLoading = isTitleKeyLoading || isAiTitleLoading;

  if (isLoading) {
    return (
      <Box align="center" width="100%" textAlign="center" dataHook={dataHook}>
        <SkeletonRectangle height="54px" width="400px" />
      </Box>
    );
  }

  return (
    <Box
      align="center"
      width="100%"
      textAlign="center"
      margin="0 auto"
      dataHook={dataHook}
    >
      <Heading className={s.title} size="large">
        {domainContent ?? aiTitle ?? <Trans i18nKey={key} values={params} />}
      </Heading>
    </Box>
  );
};
